module.exports = __webpack_public_path__ + "img/img.4ebdbe05.png";